export default __webpack_public_path__ + "static/media/404_error.80dfcd23.png";